/**
 * Created by emanuele on 04/02/2017.
 */
import React, {Component} from 'react'
import { Button, Modal, Header , Icon} from 'semantic-ui-react'
import PropTypes from 'prop-types';
class ModalConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen:false};
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickOk(){
        this.setState({ isOpen: false })
        if (this.props.onClickOk !== undefined){
            this.props.onClickOk();
        }
    }
    onClickCancel(){
        this.setState({ isOpen: false })
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    render(){
        let msgDescription = null;
        if (this.props.msgDescription){
            msgDescription = (this.props.msgDescription);
        }
        return <Modal
            trigger={this.props.children}
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            basic
            size='small'
        >
            <Header icon='warning' content={this.props.title} />
            <Modal.Content>
                <h3>{this.props.msg}</h3>
                {msgDescription}
                <h3>{this.props.question}</h3>
            </Modal.Content>
            <Modal.Actions>
                <Button color='grey' onClick={this.onClickCancel} inverted>
                    <Icon name='checkmark' /> No, annulla
                </Button>
                <Button color='red' onClick={this.onClickOk} inverted>
                    <Icon name='checkmark' />Si, prosegui
                </Button>
            </Modal.Actions>
        </Modal>
    }

}
ModalConfirm.PropTypes = {
    msg: PropTypes.string.isRequired,
    msgDescription: PropTypes.string,
    question: PropTypes.string,
    title: PropTypes.string,
    onClickOk: PropTypes.func
}

ModalConfirm.defaultProps = {
    title: "Attenzione",
    question: "Sei sicuro di voler continuare?"
};

export default ModalConfirm


/** WEBPACK FOOTER **
 ** ./src/components/ModalConfirm.js
 **/